// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise'
import type { BaseHttpRequest } from './core/BaseHttpRequest'
import type {
  InvalidateCacheForCurrentUserResponse,
  AnonymousLoginData,
  AnonymousLoginResponse,
  TokensFromRefreshTokenData,
  TokensFromRefreshTokenResponse,
  WalletChallengeData,
  WalletChallengeResponse2,
  BindWalletData,
  BindWalletResponse,
  MeResponse,
  ReportFcmTokenData,
  ReportFcmTokenResponse,
  MissionsResponse,
  FeedbackData,
  FeedbackResponse,
  GeolocationResponse,
  GetMiniQuickaccessStateResponse,
  GetMiniOmenuPointsStateResponse,
  GetUserEarningsTotalResponse,
  UserConfigResponse,
  GetBalanceResponse,
  GetActivityData,
  GetActivityResponse,
  PostTelemetryEventsData,
  PostTelemetryEventsResponse,
  ClaimBonusData,
  ClaimBonusResponse,
  GetMissionsV2Data,
  GetMissionsV2Response,
  ReportCounterData,
  ReportCounterResponse,
  GetMissionHistoryData,
  GetMissionHistoryResponse,
  GetBalanceV2Response,
  GetClientStateResponse,
  PostClientStateData,
  PostClientStateResponse,
  GetMissionsV3Data,
  GetMissionsV3Response,
  ReportCounterV3Data,
  ReportCounterV3Response,
  GetGiveawayAvailabilityData,
  GetGiveawayAvailabilityResponse,
  PostFormGiveawayData,
  PostFormGiveawayResponse,
  GetRewardStatusGiveawayData,
  GetRewardStatusGiveawayResponse,
  GetFormData,
  GetFormResponse,
  PostSubmissionsData,
  PostSubmissionsResponse,
  GetSubmissionsData,
  GetSubmissionsResponse
} from './types.gen'

export class DebugService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Invalidate Cache For Current User
   * @returns unknown Successful Response
   * @throws ApiError
   */
  public invalidateCacheForCurrentUser(): CancelablePromise<InvalidateCacheForCurrentUserResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/debug/me/invalidate-cache'
    })
  }
}

export class AuthService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Anonymous Login
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.xApiKey
   * @param data.apiKey
   * @returns Tokens Successful Response
   * @throws ApiError
   */
  public anonymousLogin(data: AnonymousLoginData): CancelablePromise<AnonymousLoginResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/auth/tokens',
      headers: {
        'X-ApiKey': data.xApiKey,
        'Api-Key': data.apiKey
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error'
      }
    })
  }

  /**
   * Tokens From Refresh Token
   * Exchanges a refresh token for a new access and refresh token pair.
   *
   * This endpoint is called by a native client in two scenarios:
   * - When the access token has expired.
   * - When the native client has been updated.
   *
   * It also allows the native client to report an updated HUID or client version.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Tokens Successful Response
   * @throws ApiError
   */
  public tokensFromRefreshToken(
    data: TokensFromRefreshTokenData
  ): CancelablePromise<TokensFromRefreshTokenResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/auth/tokens/refresh',
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        400: 'These indicate potential client-side issues or implementation bugs.',
        401: 'The client should clear existing tokens and request a new anonymous user.',
        422: 'Validation Error'
      }
    })
  }

  /**
   * Wallet Challenge
   * @param data The data for the request.
   * @param data.requestBody
   * @returns WalletChallengeResponse Successful Response
   * @throws ApiError
   */
  public walletChallenge(data: WalletChallengeData): CancelablePromise<WalletChallengeResponse2> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/auth/wallet-challenge',
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error'
      }
    })
  }

  /**
   * Bind Wallet
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown Successful Response
   * @throws ApiError
   */
  public bindWallet(data: BindWalletData): CancelablePromise<BindWalletResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/auth/bind-wallet',
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error'
      }
    })
  }
}

export class UserService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Me
   * @returns UserMe Successful Response
   * @throws ApiError
   */
  public me(): CancelablePromise<MeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/user/me'
    })
  }

  /**
   * Report Fcm Token
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown Successful Response
   * @throws ApiError
   */
  public reportFcmToken(data: ReportFcmTokenData): CancelablePromise<ReportFcmTokenResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/user/fcm-token',
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error'
      }
    })
  }

  /**
   * @deprecated
   * Missions
   * @returns MissionStatusesResponse Successful Response
   * @throws ApiError
   */
  public missions(): CancelablePromise<MissionsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/user/missions'
    })
  }

  /**
   * Feedback
   * Return 200 when the feedback email is queued, not when it is sent.
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown Successful Response
   * @throws ApiError
   */
  public feedback(data: FeedbackData): CancelablePromise<FeedbackResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/user/feedback',
      formData: data.formData,
      mediaType: 'multipart/form-data',
      errors: {
        422: 'Validation Error'
      }
    })
  }

  /**
   * Geolocation
   * @returns UserGeolocation Successful Response
   * @throws ApiError
   */
  public geolocation(): CancelablePromise<GeolocationResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/user/geolocation'
    })
  }

  /**
   * @deprecated
   * Get Mini Quickaccess State
   * Deprecated API no longer used by Mini. Kept here to make sure old clients won't break.
   * @returns UserMiniQuickaccessState Successful Response
   * @throws ApiError
   */
  public getMiniQuickaccessState(): CancelablePromise<GetMiniQuickaccessStateResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/user/mini/quickaccess'
    })
  }

  /**
   * @deprecated
   * Get Mini Omenu Points State
   * Deprecated API no longer used by Mini. Kept here to make sure old clients won't break.
   *
   * Endpoint specification can be found [here](https://docs.google.com/document/d/1JHDRvILqsZN5AVn8Sz0mlORp7FdD6oGDWpKvKQQhAbA/edit?tab=t.2vdc1vmt2u6q)
   * @returns UserMiniOMenuPointsState Successful Response
   * @throws ApiError
   */
  public getMiniOmenuPointsState(): CancelablePromise<GetMiniOmenuPointsStateResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/user/mini/omenu/points/state',
      errors: {
        403: `ApiError

* Points not enabled for user`
      }
    })
  }

  /**
   * @deprecated
   * Get User Earnings Total
   * Deprecated API no longer used by clients. Kept here to make sure old clients won't break.
   * @returns UserEarningsTotal Successful Response
   * @throws ApiError
   */
  public getUserEarningsTotal(): CancelablePromise<GetUserEarningsTotalResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/user/earnings/total'
    })
  }

  /**
   * User Config
   * @returns UserConfig Successful Response
   * @throws ApiError
   */
  public userConfig(): CancelablePromise<UserConfigResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/user/config'
    })
  }

  /**
   * Get Balance
   * @returns BalanceResponse Successful Response
   * @throws ApiError
   */
  public getBalance(): CancelablePromise<GetBalanceResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/user/balance'
    })
  }

  /**
   * Get Activity
   * @param data The data for the request.
   * @param data.cursor Cursor for the next page
   * @param data.size Page size
   * @param data.acceptLanguage
   * @returns CursorPage_ActivityEntry_ Successful Response
   * @throws ApiError
   */
  public getActivity(data: GetActivityData = {}): CancelablePromise<GetActivityResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/user/activity',
      headers: {
        'Accept-Language': data.acceptLanguage
      },
      query: {
        cursor: data.cursor,
        size: data.size
      },
      errors: {
        422: 'Validation Error'
      }
    })
  }

  /**
   * Post Telemetry Events
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown Successful Response
   * @throws ApiError
   */
  public postTelemetryEvents(
    data: PostTelemetryEventsData
  ): CancelablePromise<PostTelemetryEventsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/user/telemetry/events',
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error'
      }
    })
  }

  /**
   * Claim Bonus
   * @param data The data for the request.
   * @param data.campaignId
   * @returns CounterMissionExtra Successful Response
   * @throws ApiError
   */
  public claimBonus(data: ClaimBonusData): CancelablePromise<ClaimBonusResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/user/bonus-campaigns/{campaign_id}/claim',
      path: {
        campaign_id: data.campaignId
      },
      errors: {
        400: `ApiError

* No wallet address bound. A crypto token reward requires a wallet.`,
        409: `ApiError

* This bonus is no longer available. Please refresh your activity.`,
        422: 'Validation Error'
      }
    })
  }

  /**
   * Missions
   * @param data The data for the request.
   * @param data.xOperaRewardsEntrypoint
   * @param data.acceptLanguage
   * @returns MissionsResponseV2 Successful Response
   * @throws ApiError
   */
  public getMissionsV2(data: GetMissionsV2Data = {}): CancelablePromise<GetMissionsV2Response> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v2/user/missions',
      headers: {
        'X-OperaRewards-Entrypoint': data.xOperaRewardsEntrypoint,
        'Accept-Language': data.acceptLanguage
      },
      errors: {
        422: 'Validation Error'
      }
    })
  }

  /**
   * Report Counter
   * @param data The data for the request.
   * @param data.missionType
   * @param data.requestBody
   * @param data.forceSyncMode
   * @param data.xOperaRewardsEntrypoint
   * @param data.acceptLanguage
   * @returns CounterMissionReportResponse Successful Response
   * @throws ApiError
   */
  public reportCounter(data: ReportCounterData): CancelablePromise<ReportCounterResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/user/missions/{mission_type}/report-counter',
      path: {
        mission_type: data.missionType
      },
      headers: {
        'X-OperaRewards-Entrypoint': data.xOperaRewardsEntrypoint,
        'Accept-Language': data.acceptLanguage
      },
      query: {
        force_sync_mode: data.forceSyncMode
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        400: `ApiError

* User tried to get checkin endpoint but mission is not enabled for them

* You can't check in again yet. Please try again later.

* This action has already been completed.

* We couldn't update your progress. Please try again.`,
        409: `ApiError

* Your app state appears to be out of date. Please refresh and try again.`,
        422: 'Validation Error'
      }
    })
  }

  /**
   * Get Mission History
   * Get mission reward history for the last 7 days.
   *
   * Returns daily aggregated rewards for the specified mission type.
   * Each day shows the total reward earned.
   * @param data The data for the request.
   * @param data.missionType
   * @param data.xOperaRewardsEntrypoint
   * @param data.acceptLanguage
   * @returns MissionHistoryResponse Successful Response
   * @throws ApiError
   */
  public getMissionHistory(
    data: GetMissionHistoryData
  ): CancelablePromise<GetMissionHistoryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v2/user/missions/{mission_type}/history',
      path: {
        mission_type: data.missionType
      },
      headers: {
        'X-OperaRewards-Entrypoint': data.xOperaRewardsEntrypoint,
        'Accept-Language': data.acceptLanguage
      },
      errors: {
        400: `ApiError

* Mission history not enabled for user

* Mission type does not support history`,
        422: 'Validation Error'
      }
    })
  }

  /**
   * Get Balance V2
   * @returns BalanceV2Response Successful Response
   * @throws ApiError
   */
  public getBalanceV2(): CancelablePromise<GetBalanceV2Response> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v2/user/balance'
    })
  }

  /**
   * Get Client State
   * Get client state for the current user's app instance.
   *
   * Returns default values (False) if no state exists.
   * @returns ClientStateResponse Successful Response
   * @throws ApiError
   */
  public getClientState(): CancelablePromise<GetClientStateResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v2/user/client-state'
    })
  }

  /**
   * Post Client State
   * Update client state for the current user's app instance.
   *
   * Upserts the state - creates new record or updates existing one.
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.xOperaRewardsEntrypoint
   * @returns unknown Successful Response
   * @throws ApiError
   */
  public postClientState(data: PostClientStateData): CancelablePromise<PostClientStateResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/user/client-state',
      headers: {
        'X-OperaRewards-Entrypoint': data.xOperaRewardsEntrypoint
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error'
      }
    })
  }

  /**
   * Missions
   * @param data The data for the request.
   * @param data.xOperaRewardsEntrypoint
   * @param data.acceptLanguage
   * @returns MissionsResponseV3 Successful Response
   * @throws ApiError
   */
  public getMissionsV3(data: GetMissionsV3Data = {}): CancelablePromise<GetMissionsV3Response> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v3/user/missions',
      headers: {
        'X-OperaRewards-Entrypoint': data.xOperaRewardsEntrypoint,
        'Accept-Language': data.acceptLanguage
      },
      errors: {
        422: 'Validation Error'
      }
    })
  }

  /**
   * Report Counter
   * @param data The data for the request.
   * @param data.missionId
   * @param data.requestBody
   * @param data.forceSyncMode
   * @param data.xOperaRewardsEntrypoint
   * @param data.acceptLanguage
   * @returns CounterMissionReportResponse Successful Response
   * @throws ApiError
   */
  public reportCounterV3(data: ReportCounterV3Data): CancelablePromise<ReportCounterV3Response> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v3/user/missions/{mission_id}/report-counter',
      path: {
        mission_id: data.missionId
      },
      headers: {
        'X-OperaRewards-Entrypoint': data.xOperaRewardsEntrypoint,
        'Accept-Language': data.acceptLanguage
      },
      query: {
        force_sync_mode: data.forceSyncMode
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        400: `ApiError

* User tried to get checkin endpoint but mission is not enabled for them

* You can't check in again yet. Please try again later.

* This action has already been completed.

* We couldn't update your progress. Please try again.`,
        409: `ApiError

* Your app state appears to be out of date. Please refresh and try again.`,
        422: 'Validation Error'
      }
    })
  }
}

export class GiveawayService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get Giveaway Availability
   * @param data The data for the request.
   * @param data.acceptLanguage
   * @returns GiveawayStatus Successful Response
   * @throws ApiError
   */
  public getGiveawayAvailability(
    data: GetGiveawayAvailabilityData = {}
  ): CancelablePromise<GetGiveawayAvailabilityResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/giveaway/availability',
      headers: {
        'Accept-Language': data.acceptLanguage
      },
      errors: {
        422: 'Validation Error'
      }
    })
  }

  /**
   * Post Form Giveaway
   * @param data The data for the request.
   * @param data.requestBody
   * @param data.xOperaRewardsEntrypoint
   * @returns unknown Successful Response
   * @throws ApiError
   */
  public postFormGiveaway(data: PostFormGiveawayData): CancelablePromise<PostFormGiveawayResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/giveaway/form',
      headers: {
        'X-OperaRewards-Entrypoint': data.xOperaRewardsEntrypoint
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error'
      }
    })
  }

  /**
   * Get Reward Status Giveaway
   * @param data The data for the request.
   * @param data.xOperaRewardsEntrypoint
   * @param data.acceptLanguage
   * @returns ResponseRewardStatusGiveaway Successful Response
   * @throws ApiError
   */
  public getRewardStatusGiveaway(
    data: GetRewardStatusGiveawayData = {}
  ): CancelablePromise<GetRewardStatusGiveawayResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/giveaway/reward-status',
      headers: {
        'X-OperaRewards-Entrypoint': data.xOperaRewardsEntrypoint,
        'Accept-Language': data.acceptLanguage
      },
      errors: {
        422: 'Validation Error'
      }
    })
  }
}

export class CustomFormsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get Form
   * @param data The data for the request.
   * @param data.slug
   * @param data.acceptLanguage
   * @returns CustomFormConfig Successful Response
   * @throws ApiError
   */
  public getForm(data: GetFormData): CancelablePromise<GetFormResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/forms/{slug}',
      path: {
        slug: data.slug
      },
      headers: {
        'Accept-Language': data.acceptLanguage
      },
      errors: {
        422: 'Validation Error'
      }
    })
  }

  /**
   * Post Submissions
   * @param data The data for the request.
   * @param data.slug
   * @param data.requestBody
   * @returns CustomFormSubmissionSchema Successful Response
   * @throws ApiError
   */
  public postSubmissions(data: PostSubmissionsData): CancelablePromise<PostSubmissionsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/forms/{slug}/submissions',
      path: {
        slug: data.slug
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        409: `ApiError

* Form submission limit reached`,
        422: `ApiError

* Provided values are invalid`
      }
    })
  }

  /**
   * Get Submissions
   * @param data The data for the request.
   * @param data.slug
   * @returns CustomFormSubmissionsResponse Successful Response
   * @throws ApiError
   */
  public getSubmissions(data: GetSubmissionsData): CancelablePromise<GetSubmissionsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/forms/{slug}/submissions',
      path: {
        slug: data.slug
      },
      errors: {
        422: 'Validation Error'
      }
    })
  }
}
